module.exports = __webpack_public_path__ + "img/sdg11_id.31a41969.svg";